export default {
    yellow: '#FFEB00',
    black: '#000000',
    white: '#FFFFFF',
    red: '#DB0716',
    headerHeight: '80px',
    footerHeight: '140px',
    interface: 'Interface',
}